
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ProductContainer from "./ProductContainer";
import i18nLabels from './Product.i18n'
import DecorateContainer from "components/DecorateContainer";
import { productSelector } from "app/selectors";
import { useHistory } from "react-router-dom";
export default function Product(props) {
    const dispatch = useDispatch();
    const history = useHistory();
    const infoProduct = useSelector(productSelector)
    const { productScan, productInfo } = infoProduct
    const productProps = {
        ...props,
        i18nLabels,
        productScan,
        productInfo,
        history,
        dispatch,
    };
    return <DecorateContainer {...productProps} childComponent={ProductContainer} />
}
